module.exports = __webpack_public_path__ + "img/image-6.9a6bcb36.webp";